import React, { useState } from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Person as PersonIcon,
  SmartToy as SmartToyIcon,
} from '@mui/icons-material';
import { MAX_PREVIEW_LENGTH } from './constants';

export default function MessageBubble({ message }) {
  const [expanded, setExpanded] = useState(false);
  const isUser = message.role === 'user';
  const isLong = message.content.length > MAX_PREVIEW_LENGTH;
  const displayContent =
    isLong && !expanded
      ? message.content.slice(0, MAX_PREVIEW_LENGTH) + '...'
      : message.content;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: isUser ? 'flex-end' : 'flex-start',
        mb: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          mb: 0.5,
          flexDirection: isUser ? 'row-reverse' : 'row',
        }}
      >
        {isUser ? (
          <PersonIcon sx={{ fontSize: 18, color: 'primary.main' }} />
        ) : (
          <SmartToyIcon sx={{ fontSize: 18, color: 'success.main' }} />
        )}
        <Typography variant='caption' color='text.secondary'>
          {message.stepLabel}
        </Typography>
      </Box>
      <Paper
        elevation={1}
        sx={{
          px: 2,
          py: 1.5,
          maxWidth: '85%',
          borderRadius: 2,
          bgcolor: isUser ? 'primary.main' : 'grey.100',
          color: isUser ? 'white' : 'text.primary',
          borderTopRightRadius: isUser ? 0 : 16,
          borderTopLeftRadius: isUser ? 16 : 0,
        }}
      >
        <Typography
          variant='body2'
          sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
        >
          {displayContent}
        </Typography>
        {isLong && (
          <Button
            size='small'
            onClick={() => setExpanded(!expanded)}
            sx={{
              mt: 0.5,
              minWidth: 0,
              textTransform: 'none',
              px: 1,
              py: 0.25,
              borderRadius: 10,
              ...(isUser
                ? {
                    color: 'common.white',
                    border: '1px solid rgba(255, 255, 255, 0.85)',
                    bgcolor: 'rgba(255, 255, 255, 0.22)',
                    '&:hover': {
                      bgcolor: 'rgba(255, 255, 255, 0.38)',
                      borderColor: 'common.white',
                    },
                  }
                : { p: 0 }),
            }}
            endIcon={
              expanded ? (
                <ExpandLessIcon sx={{ fontSize: 16 }} />
              ) : (
                <ExpandMoreIcon sx={{ fontSize: 16 }} />
              )
            }
          >
            {expanded ? 'Show less' : 'Show more'}
          </Button>
        )}
      </Paper>
    </Box>
  );
}
